import React from 'react';
import { Box, Text } from 'components/Wrapped';

const AnalyticsItem = ({ data: { item = '---', name }, size }) => {
  return (
    <Box
      pad="none"
      justify={size === 'small' ? 'between' : 'center'}
      gap="2px"
      style={size === 'small' ? { display: 'flex', flexDirection: 'row' } : undefined}
    >
      <Text color="#B4B6B7" size="12px" weight={500} style={{ lineHeight: '16px' }}>
        {name}
      </Text>
      <Text color="white" size="14px" weight={600} style={{ lineHeight: '17px' }} textAlign="start">
        {item}
      </Text>
    </Box>
  );
};

export default AnalyticsItem;
